import Header from 'components/header/Header';
import React, { useState } from 'react';
import { useIngredientInfo } from 'redux/hooks/IngredientDetail';
import { useGetHeaderButtons } from './hooks';
import RMModal from 'components/modal/RMModal';

const IngredientHeader = ({ closeModal }) => {
  const ingredientInfo = useIngredientInfo();
  const [error, setError] = useState({ show: false, msg: '' });
  const saveDiscardButtons = useGetHeaderButtons({
    setError,
    ingredientInfo,
    closeModal,
  });

  const hideModal = () => {
    setError({ ...error, show: false });
  };

  const errorBody = () => {
    return error.msg.split('\n').map((msg) => (
      <>
        {msg}
        <br />
      </>
    ));
  };

  return (
    <>
      <Header
        containerStyle={{ height: '100%' }}
        headerButtons={[]}
        isNewTheme={true}
        title={ingredientInfo.longName || 'New Ingredient'}
        extendedActionSection={saveDiscardButtons}
      />
      <RMModal
        id="ingredientheader-error-modal"
        setShowModal={(e) => setError({ ...error, show: e })}
        showModal={error.show}
        onOk={hideModal}
        isOkOnly
        heading="Error"
        body={errorBody()}
        okButtonText="Ok, Close"
      />
    </>
  );
};
export default IngredientHeader;
